<div role="document ">
    <div class="modal-content {{class}}">
      <div class="modal-header" *ngIf="showHeader">
        <h5 class="modal-title">{{title}}</h5>
        <a type="button" class="close" aria-label="Close" (click)="close()" >
          <span aria-hidden="true"><b>&times;</b></span>
        </a>
      </div>
      <div class="modal-body">
        <ng-content #content></ng-content>
      </div>
      <div class="modal-footer" *ngIf="showFooter">
        <button type="button" class="btn btn-outline-dark" (click)="close('cancel')">{{lblCancelButton}}</button>
        <button *ngIf="showConfirmButton" type="button" class="btn btn-outline-success" (click)="close('success')">{{lblConfirmButton}}</button>
      </div>
    </div>
  </div>